// import { Navigate } from "react-router-dom";
// import { getUserDetailsInLocalStorage } from "./UserDetails";

// const ScopeProtectedRoute = ({ children, scopes }) => {
//   const user = getUserDetailsInLocalStorage();
//   const role = user.role;
  
//   if(role == "admin") {
//     return children;
//   }

//   if(!scopes) {
//     return children;
//   }

//   const userScopes = new String(user.scope).split(",");

//   // check scopes
//   const hasAccess = scopes?.some((scope)=>userScopes?.includes(scope));

//   if(hasAccess) {
//     return children;
//   }

//   return <Navigate to="/no-access" replace />;
// };

// export default ScopeProtectedRoute;


import { Navigate } from "react-router-dom";
import { getUserDetailsInLocalStorage } from "./UserDetails";

const ScopeProtectedRoute = ({ children, scopes, module }) => {
  const user = getUserDetailsInLocalStorage();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Module check if provided (e.g. "item_issue")
  if (module && user.role !== "superadmin") {
    let modulesStr = user.enabled_modules;
    try {
      const rawStore = localStorage.getItem("store_details");
      if (rawStore) {
        const store = JSON.parse(rawStore);
        if (store?.enabled_modules !== undefined && store?.enabled_modules !== null) {
          modulesStr = store.enabled_modules;
        }
      }
    } catch (e) {}

    if (modulesStr !== undefined && modulesStr !== null) {
      const list = modulesStr.split(",").map(m => m.trim().toLowerCase());
      const mod = module.toLowerCase();
      const isAllowed = list.includes(mod) || 
        (mod === "item_issue" && list.includes("item_issue_return")) || 
        (mod === "pool" && list.includes("swimming_pool")) ||
        (mod === "gym" && (list.includes("gym_management") || list.includes("gym_biometrics")));
      if (!isAllowed) {
        return <Navigate to="/no-access" replace />;
      }
    }
  }

  const { role, scope } = user;
  
  if (role === "admin") {
    return children;
  }

  if (!scopes) {
    return children;
  }

  // FIX: Handle null/undefined scope
  const userScopes = scope ? String(scope).split(",") : [];
  
  const hasAccess = scopes?.some((requiredScope) => 
    userScopes?.includes(requiredScope)
  );

  if (hasAccess) {
    return children;
  }

  return <Navigate to="/no-access" replace />;
};

export default ScopeProtectedRoute;